/* src/app/components/licenses-components/licenses-license/licenses-license.component.scss */
/*# sourceMappingURL=licenses-license.component.css.map */
